module.exports = __webpack_public_path__ + "static/media/StrengtheningOurSocialSupportNetwork.dc439ae7.jpg";